/* eslint-disable no-case-declarations */
import {
  TRANSLATION_DETAILS_SUCCESS
} from "../CONSTANTS";

const initialState = {
  i18n:{version:1}
};


const translationReducer = (state = initialState, action) => {
  switch (action.type) {
    case TRANSLATION_DETAILS_SUCCESS:
      console.log("translationREducer>TRANSLATION_DETAILS_SUCCESS.....");
      return {
        ...state,
        i18n: {
          ...state.i18n,
          ...action.payload,
          version:
            state.i18n && state.i18n.version ? state.i18n.version + 1 : 1,
        },
      };
    default:
      return state;
  }
};

export default translationReducer;
